export default "__VITE_ASSET__DZOCHS0N__"